var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"liked"},[_c('div',{staticClass:"liked-item"},[_c('liked-product-card')],1),_c('div',{staticClass:"liked-item"},[_c('liked-product-card')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }